<script>
import Service from '../../services/equipment-operation';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import InputNumber from 'primevue/inputnumber';

import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ['visible', 'operationDate', 'isGas', 'tanks', 'calculatorData'],
  emits: ['close-deviation-calculator-dialog', 'after-deviation-calculator-saved'],
  setup: () => ({ v$: useVuelidate() }),
  components: {
    InputNumber,
  },
  data() {
    return {
      submitted: false,
      activeTab: 0,
      calculator: [],
      enableSaving: false,

      calculatorResponse: null
    }
  },
  validations() {
    let validations = [];

    this.tanks.forEach((_, index) => {
      validations[index] = {
        liquidTemperature: {required},
        liquidLevel: {required},
        gasPressure: {customValidation: value => !this.isGas || value},
        gasTemperature: {customValidation: value => !this.isGas || value},
      }
    });

    return {calculator: validations}
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    }
  },
  mounted() {
    
  },
  created(){
    this.tanks.forEach((_, index) => {
      this.calculator[index] = {
        liquidTemperature: null,
        liquidLevel: null,
        gasPressure: null,
        gasTemperature: null,
        lossValue: 0,
        excessValue: 0,
        difference: 0
      };
    });
  },
  watch: {
    tanks(newValue){
      newValue.forEach((_, index) => {
        this.calculator[index] = {
          liquidTemperature: null,
          liquidLevel: null,
          gasPressure: null,
          gasTemperature: null,
          lossValue: 0,
          excessValue: 0,
          difference: 0
        };
      });
    }
  },
  methods: {
    updateData(){

      this.tanks.forEach((tank) => {
        const tabIndex = this.tanks.findIndex((item) => item === tank);
        this.calculator[tabIndex] = this.calculatorData[tank];
        if(this.calculatorData[tank]?.referenceMeasureUnit == 'KG'){
          this.calculator[tabIndex].difference = this.calculatorData[tank].stockWeightDifference;
        }else if(this.calculatorData[tank]?.referenceMeasureUnit == 'LT'){
          this.calculator[tabIndex].difference = this.calculatorData[tank].stockVolumeDifference;
        }
      })
    },
    calculate(){
      this.submitted = true;
      let valid = !this.v$.calculator.$invalid;

      if (valid){
        const body = {
          operationDate: this.operationDate,
          tankCode: this.tanks[0],
          piTemperature: this.calculator[0]?.liquidTemperature,
          piProductLevel: (this.calculator[0]?.liquidLevel).toFixed(0),
          piGasPressure: this.calculator[0]?.gasPressure,
          piGasTemperature: this.calculator[0]?.gasTemperature,
          linkedTanks: []
        }

        this.tanks.forEach((tankCode, index) => {
          if(index){
            body.linkedTanks.push({
              operationDate: this.operationDate,
              tankCode,
              piTemperature: this.calculator[index]?.liquidTemperature,
              piProductLevel: (this.calculator[index]?.liquidLevel).toFixed(0),
              piGasPressure: this.calculator[index]?.gasPressure,
              piGasTemperature: this.calculator[index]?.gasTemperature,
            })
          }
        })
        this.$store.dispatch("generic/setLoading", true);
        
        Service.calculateCVTDeviation(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.enableSaving = true;
            this.calculatorResponse = data;
            data.forEach((item) => {
              const tabIndex = this.tanks.findIndex((tank) => tank === item.isabTankCode);
              if(this.tanks.length > 1) {
                if (tabIndex >= 0){
                  this.calculator[tabIndex].lossValue = item.lossValue;
                  this.calculator[tabIndex].excessValue = item.excessValue;
                  if (item.referenceMeasureUnit === 'KG'){
                    this.calculator[tabIndex].difference = item.stockWeightDifference;
                  } else if (item.referenceMeasureUnit === 'LT'){
                    this.calculator[tabIndex].difference = item.stockVolumeDifference;
                  }
                } else {
                  this.calculator.totalLoss = item.lossValue;
                  this.calculator.totalExcess = item.excessValue;
                  if (item.referenceMeasureUnit === 'KG'){
                    this.calculator.totalDifference = item.stockWeightDifference;
                  } else if (item.referenceMeasureUnit === 'LT'){
                    this.calculator.totalDifference = item.stockVolumeDifference;
                  }
                }
              } else {
                this.calculator[0].lossValue = item.lossValue;
                this.calculator[0].excessValue = item.excessValue;
                if (item.referenceMeasureUnit === 'KG'){
                    this.calculator[0].difference = item.stockWeightDifference;
                  } else if (item.referenceMeasureUnit === 'LT'){
                    this.calculator[0].difference = item.stockVolumeDifference;
                  }
              }
            })
          } else {
            this.$toast.add({detail: message || this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      } else {
        this.$toast.add({detail: this.$t('messages.verify_all_tabs_validation'), life:3000, severity:'error'});

      }
    },
    closeDialog() {
      this.$emit("close-deviation-calculator-dialog", true);
    },
    save(){
      this.$store.dispatch("generic/setLoading", true);
      const body = this.calculator.map((item) => {
        item.sent = false;
        const {id, ...allProperty} = item;
        return allProperty;
      })
      Service.saveCVTDeviation(this.calculatorResponse, ({success, message}) =>{
        this.$store.dispatch("generic/setLoading", false);
        if(success){
          this.closeDialog();
          this.$emit("after-deviation-calculator-saved");
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        } else {
          this.$toast.add({detail: message || this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    resetCalculation(index){
      this.calculator[index].lossValue = null;
      this.calculator[index].excessValue = null;
      this.calculator[index].difference = null;
      this.enableSaving = false;
    },
    importFromPI(){
      this.$store.dispatch("generic/setLoading", true);
      Service.importFromPI({date: this.operationDate, tank: this.tanks[this.activeTab]}, ({success, data}) =>{
        this.$store.dispatch("generic/setLoading", false);
        if(success){
          this.enableSaving = false;
          data.reverse().forEach(({items}) => {
            const [{description, value, uoM}] = items;
            // const key = {
            //   'Level': 'liquidLevel',
            //   'Temperature': 'liquidTemperature',
            //   'Pressure': 'gasPressure',
            //   'Gas Temperature': 'gasTemperature'
            // }?.[description];

            // key && (this.calculator[this.activeTab][key] = value);
            switch(description){
                case 'Level':
                    this.calculator[this.activeTab].liquidLevel = value;
                break;
                case 'Temperature':
                this.calculator[this.activeTab].liquidTemperature = value;
                break;
                case 'Pressure':
                    if("BAR" == uoM.toUpperCase()){
                      this.calculator[this.activeTab].gasPressure = value;
                    }
                break;
                case 'Gas Temperature':
                  this.calculator[this.activeTab].gasTemperature = value;
                break;
            }
          })
        } else {
          this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    }
  }
}

</script>

<template>
  <main>
    <Dialog :header="$t('cvtDeviation.deviationCalculator')" :visible="visible" :modal="true" :closable="false"
      :style="{ width: '50vw' }">
      <div class="grid">
        <Button icon="pi pi-times" class="p-button-sm close-button" @click="closeDialog(true)" />
      </div>
      <TabView v-model:activeIndex="activeTab" class="tank-box">
        <TabPanel :header="tank" :key="tank" v-for="tank, index in tanks">
          <Fieldset :legend="$t('PI/LiveInformation')">
            <div class="grid">
              <div class="col-12 lg:col-6">
                <label for="temperature" :class="{'p-error':v$.calculator[index].liquidTemperature.$invalid && submitted}">{{$t('cvtDeviation.temperature')}}</label>
                <InputNumber @input="resetCalculation(index)" mode="decimal"
                :maxFractionDigits="2" name="temperature" v-model="calculator[index].liquidTemperature" :class="{'p-invalid':v$.calculator[index].liquidTemperature.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <div v-if="(v$.calculator[index].liquidTemperature.$invalid && submitted) || v$.calculator[index].liquidTemperature.$pending.$response">
                  <small class="p-error" v-for="error in v$.calculator[index].liquidTemperature.$invalid.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div class="col-12 lg:col-6">
                <label for="productLevel" :class="{'p-error':v$.calculator[index].liquidLevel.$invalid && submitted}">{{$t('cvtDeviation.productLevel')}}</label>
                <InputNumber @keyup="resetCalculation(index)" name="productLevel" v-model="calculator[index].liquidLevel" :class="{'p-invalid':v$.calculator[index].liquidLevel.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <div v-if="(v$.calculator[index].liquidLevel.$invalid && submitted) || v$.calculator[index].liquidLevel.$pending.$response">
                  <small class="p-error" v-for="error in v$.calculator[index].liquidLevel.$invalid.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div class="col-12 lg:col-6" v-if="!isGas">
                <Button :label="$t('cvtDeviation.btn.importFromPI')" icon="pi pi-upload" class="p-button-info" @click="importFromPI" />
              </div>
            </div>
            <div class="grid" v-if="isGas">
              <div class="col-12 lg:col-6">
                <label for="gasTemperature" :class="{'p-error':v$.calculator[index].gasTemperature.$invalid && submitted}">{{$t('cvtDeviation.gasTemperature')}}</label>
                <InputNumber @keyup="resetCalculation(index)" mode="decimal" :maxFractionDigits="2" name="gasTemperature" v-model="calculator[index].gasTemperature" :class="{'p-invalid':v$.calculator[index].gasTemperature.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <div v-if="(v$.calculator[index].gasTemperature.$invalid && submitted) || v$.calculator[index].gasTemperature.$pending.$response">
                  <small class="p-error" v-for="error in v$.calculator[index].gasTemperature.$invalid.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>    
              <div class="col-12 lg:col-6">
                <label for="gasPressure" :class="{'p-error':v$.calculator[index].gasPressure.$invalid && submitted}">{{$t('cvtDeviation.gasPressure')}}</label>
                <InputNumber @keyup="resetCalculation(index)" mode="decimal" :maxFractionDigits="2" name="gasPressure" v-model="calculator[index].gasPressure" :class="{'p-invalid':v$.calculator[index].gasPressure.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <div v-if="(v$.calculator[index].gasPressure.$invalid && submitted) || v$.calculator[index].gasPressure.$pending.$response">
                  <small class="p-error" v-for="error in v$.calculator[index].gasPressure.$invalid.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>    
              <div class="col-12 lg:col-6 text-center align-self-end" v-if="isGas">
                <Button :label="$t('cvtDeviation.btn.importFromPI')" icon="pi pi-upload" class="p-button-info" @click="importFromPI" />
              </div>
            </div>
          </Fieldset>
          <div class="grid mt-3">
            <div class="col-12 lg:col-4 pt-1 pb-1">
              <label>{{$t('cvtDeviation.difference') + ': ' + (calculator[activeTab]?.difference || 0)}}</label>
            </div>
            <div class="col-12 lg:col-4 pt-1 pb-1">
              <label>{{$t('cvtDeviation.lossValue') + ': ' + (calculator[activeTab]?.lossValue || 0)}}</label>
            </div>
            <div class="col-12 lg:col-4 pt-1 pb-1">
              <label>{{$t('cvtDeviation.excessValue') + ': ' + (calculator[activeTab]?.excessValue || 0)}}</label>
            </div>
          </div>
        </TabPanel>
      </TabView>
      <div class="grid mt-3 px-3" v-if="tanks.length > 1">
        <div class="col-12 lg:col-4 pt-1 pb-1">
          <label>{{$t('cvtDeviation.totalDifference') + ': ' + (calculator?.totalDifference || 0)}}</label>
        </div>
        <div class="col-12 lg:col-4 pt-1 pb-1">
          <label>{{$t('cvtDeviation.totalLoss') + ': ' + (calculator?.totalLoss || 0)}}</label>
        </div>
        <div class="col-12 lg:col-4 pt-1 pb-1">
          <label>{{$t('cvtDeviation.totalExcess') + ': ' + (calculator?.totalExcess || 0)}}</label>
        </div>
      </div>
      <div class="grid mt-5 px-3">
        <div class="col-12 lg:col-6 text-center lg:text-left">
          <Button :label="$t('cvtDeviation.btn.calculate')" icon="pi pi-table" class="p-button-info" @click="calculate" />
        </div>
        <div class="col-12 lg:col-6 text-center lg:text-right">
          <Button :label="$t('btn.save')" icon="pi pi-save" class="p-button-info" @click="save" :disabled="!enableSaving" />
        </div>
      </div>
    </Dialog>
  </main>
</template>

<style scoped>

  .tank-box{
    border: 1px solid #dee2e6;
    border-width: 0 0 2px 0;
  }

  .close-button{
    position: absolute;
    top: 21px;
    right: 21px;
  }
</style>